import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
// import DataReportTable from './DataReportTable'
import AttendanceAnalysisReportTable from './AttendanceAnalysisReportTable'

import Loading from 'src/helpers/commons/loader'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { useDownloadExcel } from 'react-export-table-to-excel'
import { YesNoOptions } from 'src/helpers/commons/dropdownOptions'
import AttendanceReportLegends from 'src/widgets/Legends/AttendanceReportLegends'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import { OvertimeFormPDF } from 'src/PDF/OvertimeFormPDF'

export default function OvertimeReport() {
  const Base = new BaseListing()
  const tableRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [Employees, setEmployees] = useState([])
  const [Months, setMonths] = useState([])
  const [month, setMonth] = useState("")
  const [Years, setYears] = useState([])
  const [year, setYear] = useState("")
  const [isOfficer, setIsOfficer] = useState(2)
  const [branches, setBranches] = useState([])
  const [designations, setDesignations] = useState([])
  const [errors, setErrors] = useState([])
  const [reportData, setReportData] = useState([])
  const [dates, setDates] = useState([])
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [isMore, setIsMore] = useState(false)

  const generatePDF = () => {
    const doc = new jsPDF('landscape', 'mm', [360, 447])
    const logo = 'assets/wil-icon.png'
    const img = new Image()
    var totalPagesExp = '{total_pages_count_string}'
    let yPosition = 49

    const pageWidth1 = doc.internal.pageSize.width
    doc.setTextColor('#3c4b64')
    doc.setFont('Helvetica', 'bold')
    doc.setFontSize(14)
    // doc.text('Legend:', pageWidth1 - 430, 43, { align: 'left' })
    doc.setTextColor('#3c4b64')
    doc.setFont('Helvetica', 'normal')
    doc.setFontSize(12)
    // Set bold font for labels
    doc.setFont('Helvetica', 'bold')

    // // Write labels with bold font
    // doc.text('. A:', pageWidth1 - 425, 50)
    // doc.text('. P:', pageWidth1 - 425, 55)
    // doc.text('. L:', pageWidth1 - 425, 60)
    // doc.text('. MV:', pageWidth1 - 425, 65)
    // doc.text('. PH:', pageWidth1 - 425, 70)
    // doc.text('. WH:', pageWidth1 - 425, 75)
    // doc.text('. M(IN):', pageWidth1 - 425, 80)
    // doc.text('. M(OUT):', pageWidth1 - 425, 85)

    // Reset font to normal style
    // doc.setFont('Helvetica', 'normal')

    // // Write descriptions in normal style
    // doc.text('Absent', pageWidth1 - 417, 50)
    // doc.text('Present', pageWidth1 - 417, 55)
    // doc.text('Leave', pageWidth1 - 417, 60)
    // doc.text('On Move', pageWidth1 - 414, 65)
    // doc.text('Public Holiday', pageWidth1 - 414, 70)
    // doc.text('Weekly Holiday', pageWidth1 - 414, 75)
    // doc.text('Check IN Missing', pageWidth1 - 410, 80)
    // doc.text('Check OUT Missing', pageWidth1 - 405, 85)

    // doc.setTextColor('#3c4b64')
    // doc.setFont('Helvetica', 'bold')
    // doc.setFontSize(14)
    // doc.text('** All values are in min', pageWidth1 - 430, 93, { align: 'left' })

    // const getPdfDifferenceData = (date, record) => {
    //   let difference = '-'
    //   record.map((item) => {
    //     if (item.hasOwnProperty(date)) {
    //       difference = item[date]
    //     }
    //   })
    //   return difference
    // }

    const getPdfDifferenceColor = (date, record) => {
      const difference = getPdfDifferenceData(date, record)
      let color
      if (difference === 'A' || parseFloat(difference) < 0) {
        color = '#FF0000'
      } else if (difference === 'L') {
        color = '#0000FF'
      } else if (
        typeof difference === 'number' &&
        !Number.isNaN(difference) &&
        parseFloat(difference) > 0
      ) {
        color = '#008000'
      } else {
        color = '#000000'
      }

      return color
    }

    const headRows = [
      {
        content: 'Sr',
      },
      {
        dataKey: 'id',
        content: 'ID',
      },
      {
        dataKey: 'full_name',
        content: 'Full Name',
      },
      {
        dataKey: 'designation.name',
        content: 'Designation',
      },
      {
        dataKey: 'presents',
        content: 'Presents',
      },
      {
        dataKey: 'absents',
        content: 'Absents',
      },
      {
        dataKey: 'leaves',
        content: 'Leaves',
      },
      {
        dataKey: 'late_coming_days',
        content: 'Late Coming Days',
      },
      {
        dataKey: 'late_coming_mints',
        content: 'Late Coming Minutes',
      },

      {
        dataKey: 'early_going_days',
        content: 'Early Going Days',
      },
      {
        dataKey: 'early_going_mints',
        content: 'Early Going Minutes',
      },
      {
        dataKey: 'deductions',
        content: 'Deduction',
      },
      {
        dataKey: 'overtime_hours',
        content: 'OT Hours',
      },
      {
        dataKey: 'difference',
        content: 'Difference',
      },

      {
        dataKey: 'total_difference',
        content: 'Total Deduction',
      },

    ]

    const employeeDetails = reportData.map((employee, index) => [
      index + 1,
      { content: employee.id, styles: { textColor: 'black' } },
      { content: employee.full_name, styles: { textColor: '#0000FF', halign: 'left' } },
      { content: employee.designation?.name || '', styles: { textColor: '#0000FF', halign: 'left' } },
      { content: employee.total_present, styles: { textColor: 'green' } },
      { content: employee.total_absent, styles: { textColor: employee.total_absent > 0 ? 'red' : 'black' } },
      { content: employee.total_leave, styles: { textColor: 'green' } },
      { content: employee.total_lates, styles: { textColor: 'blue' } },
      { content: wtRoundNumberToSpecifedDigits(employee.total_lates_min) },
      { content: employee.total_early, styles: { textColor: 'blue' } },
      { content: wtRoundNumberToSpecifedDigits(employee.total_early_min), styles: { textColor: employee.total_early_min > 0 ? 'red' : 'black' } },
      { content: employee.deductions, styles: { textColor: employee.deductions > 0 ? 'red' : 'black', textWidth: '50px' } },
      { content: employee.total_overtime, styles: { textColor: 'blue' } },
      { content: wtRoundNumberToSpecifedDigits(employee.total_difference), styles: { textColor: 'blue' } },
      { content: employee.total_deduction, styles: { textColor: employee.total_deduction > 0 ? 'red' : 'black' } },
    ])

    doc.autoTable({
      head: [headRows],
      body: employeeDetails,
      startY: 50.5,
      margin: { top: 50, bottom: 20, left: 10, right: 10 },
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 430,
      styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        setFontSize: 8,
        font: 'helvetica',
      },
      columnStyles: {
        // 2: { columnWidth: 20 },

        11: { columnWidth: 20.5 },
      },

      didDrawPage: function (data) {
        let pageNo = doc.internal.getNumberOfPages()
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth() // Header

        doc.setTextColor('#3c4b64')
        doc.setFont('Helvetica', 'bold') //Header middle branch logo

        doc.addImage(logo, 'PNG', pageWidth - 430, 4, 25, 25)
        doc.line(pageWidth - 404, 7, pageWidth - 404, 27) // Adjust the coordinates as needed
        doc.setFontSize(11)
        doc.text('Al Malik', pageWidth - 401, 10, { align: 'left' })
        doc.setFont('Helvetica')
        doc.text('Enterprise', pageWidth - 401, 15)
        // doc.text('LIMITED', pageWidth - 401, 20)
        // doc.setFontSize(9)
        // doc.text('www.wahindustries.com', pageWidth - 401, 25)

        doc.setFontSize(14)
        doc.text('Analaysis Report for the Month of ' + moment().format('MMM YYYY'), pageWidth - 20, 10, { align: 'right' }) // Add header separator

        yPosition -= -5 // Set alignment for the text that follows the line
        doc.setFont('Helvetica')
        doc.setFontSize(12)
        doc.setTextColor('#3c4b64')

        //Page No
        var str = 'Page ' + pageNo
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }

        doc.setTextColor('black')
        doc.text(str, 10, pageHeight - 4)
      },
    })

    doc.setFontSize(10)
    const printReport =
      'This Report is printed through ERP at ' + moment().format('YYYY-MM-DD HH:mm:ss')
    const styleReport = { halign: 'center' }
    const pageWidth = doc.internal.pageSize.width
    const textWidth =
      (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const startXForPrintReport = (pageWidth - textWidth) / 2
    const startYForPrintReport = doc.autoTable.previous.finalY + 20

    doc.text(printReport, startXForPrintReport, startYForPrintReport, styleReport)

    doc.setTextColor('#3c4b64')
    doc.setFontSize(9)
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    doc.save('attendanceAnalysisReport.pdf')
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Attendance Analysis Report',
    sheet: 'sheet',
  })

  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    // if (key === 'designation_id') {
    //   setDesignationId(val.value)
    //   setDesignationName(val.label)
    // }
    // if (key === 'employee_id') {
    //   setEmployeeId(val.value)
    //   setEmployeeName(val.label)
    // }
  }

  const getReportData = () => {
    setIsLoading(true)
    wtApiCall(
      'reports/employee_attendance_analysis_report',
      {
        from_date: month,
        to_date: year,
        is_officer: isOfficer,
        department_id: department_id,
      },
      'get',
      (response) => {
        const { data } = response
        setReportData(data.employees)
        setDates(data.dates)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }
  useEffect(() => {
    Base.dropdownData(
      'employees,branches,designations,attendance_months,attendance_years,departments',
      {},
      [setEmployees, setBranches, setDesignations, setMonths, setYears, setDepartments],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Attendance Analysis Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <div className="form-group">
                        <label>From Date</label>
                        <input type="date" className='form-control' value={month} onChange={(ev) => setMonth(ev.target.value)} />
                        {errors.attendance_date && (
                          <ErrorMessage messages={errors.attendance_date} />
                        )}
                      </div>
                    </CCol>
                    <CCol md={2}>
                      <div className="form-group">
                        <label>To Date:</label>
                        <input type="date" className='form-control' value={year} onChange={(ev) => setYear(ev.target.value)} />
                        {errors.attendance_date && (
                          <ErrorMessage messages={errors.attendance_date} />
                        )}
                      </div>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() => getDepartments(branchId)}
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      {/* <CButton
                        color="warning"
                        className="text-white"
                        onClick={() => setIsMore(!isMore)}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        More
                      </CButton> */}
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      {Base.hasRights('Export Employee Attendance Analysis Report') && (
                        <CButton
                          color="success"
                          onClick={onDownload}
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          className="text-white"
                        >
                          Export
                        </CButton>
                      )}
                      {Base.hasRights('Print Employee Attendance Analysis Report') && (
                        <CButton
                          color="danger"
                          className="text-white"
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          onClick={generatePDF}
                        >
                          PDF
                        </CButton>
                      )}
                      {/* {Base.hasRights('Print Overtime Report') && (
                        <CButton
                          color="info"
                          className="text-white"
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          onClick={OvertimeFormPDF}
                        >
                          OT Form
                        </CButton>
                      )} */}
                    </CCol>


                  </CRow>

                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        <br />
        {/* <AttendanceReportLegends /> */}
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table" ref={tableRef}>
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <AttendanceAnalysisReportTable
                      reportData={reportData}
                      isOfficer={isOfficer}
                      setReportData={(data) => setReportData(data)}
                      isLoading={isLoading}
                      ref={tableRef}
                    />
                  ) : (
                    <center style={{ fontSize: '19px', fontWeight: 'bold' }}>
                      No record to show...
                    </center>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
